export const USER_LIST_REQUEST="USER_LIST_REQUEST"
export const USER_LIST_SUCCESS="USER_LIST_SUCCESS"
export const USER_LIST_FAIL="USER_LIST_FAIL"
export const SAVE_USER_INFO="SAVE_USER_INFO";
export const LOGOUT="LOGOUT";